import { gql, useQuery } from 'glimmer-apollo'


export async function fetchExtendables(context: Object): Promise<any> {
  const extendablesQuery = useQuery<Extendables>(context, () => [
    query,
    {
      variables: {
        input: {
          ownerType: 'SPINNAKER_EMBER_EXTENSION',
          extendableSlugs: ['PEEK_NGW_EMBER_EMBEDS_V1']
        }
      },
      onError: (error) => {
        throw new Error(`Failed to fetch account. ${error.message}`, { cause: error })
      }
    }
  ])

  return extendablesQuery.refetch()
}

const query = gql`fragment ViewDependency on AppRegistryEmberDependency {
  url
  name
  __typename
  isMainScript
  scriptConfig
  type
}

query InstalledExtendables($input: InstalledExtendablesInput!) {
  installedExtendables(input: $input) {
    ownerType
    config {
      ... on AppRegistryEmberExtension {
        data {
          isGlobalScope
          keepObservingForDomChanges
          dependencies {
            ...ViewDependency
          }
          mainDependency {
            ...ViewDependency
          }
          ... on AppRegistryEmberGenericData {
            runOnSelector
            __typename
          }
          ... on AppRegistryEmberHtmlData {
            targetSelector
            html
          }
        }
        type
        jwtToken
        __typename
      }
    }
  }
}`
